<template src="./Index.html">
</template>

<script>
    import AddView from "./actions/Add";
    import EditView from "./actions/Edit";
    import DetailsView from "./details/Details";

    export default {
        components: {
            AddView,
            EditView,
            DetailsView,
        },        created() {
            this.getAll();
            this.$store.dispatch("lookups/getLookups");
            this.$store.dispatch("lookups/getVacationTypes");
        },
        computed: {
               userTypes() {
                return [
                    { value: true, label: "عبر الموظف" },
                    { value: false, label: "عبر الادارة " }

                ]
            },
            vacationTypes() {
                return this.$store.state.lookups.vacationTypes;
            },
            info() {
                return this.$store.state.leaves.leaves;
            },
            pageCount() {
                return Math.ceil(
                    this.$store.state.leaves.totalItems / this.filters.pageSize
                );
            },
        },
        data() {
            return {
                dialog: false,
                dialogType: null,
                dialogMessage: "",
                view:0,
               
                headers: [
            
                    {
                        text: "نوع الاجازة",
                        value: "vacationType",
                        sortable: false,
                        align: "start",
                    },

                    {
                        text: "تاريخ البداية ",
                        value: "startDate",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "مدة الاجازة بالايام ",
                        value: "duration",
                        sortable: false,
                        align: "center",
                    },

                    { text: "نوع التقديم ", value: "userType", sortable: false },
                    { text: "الحالة ", value: "status", sortable: false },
                  
                    {
                        text: "الإجراءات",
                        value: "actions",
                        sortable: false,
                        align: "center",
                    },
                ],
                items: [
                    {
                        text: "الاجازات ",
                    },
                    {
                        text: "طلبات الاجازات",
                    },
                ],
                totalItems: 0,
                subtitle: "طلبات الاجازات",
                filters: {
                    page: 1,
                    pageSize: 10,
                    vacationTypeId: null,
                    byEmployee: null,

                },

            };
        },
        methods: {
            editItem(item) {
                this.itemId = item.employeeLeaveId;
                this.view = 2;
                this.items.push({ text: "تعديل بيانات الاجازة" });

            },
            showDialog(item, type) {
                switch (type) {
                    case "delete":
                        this.dialogMessage = "هل انت متأكد من بحذف طلب الاجازة";
                        break;
                  

                }
                this.dialogType = type;
                this.itemId = item.employeeLeaveId;
                this.dialog = true;
            },

            confirmDialog() {
                this.$store.dispatch(`leaves/${this.dialogType}`, this.itemId);
                this.cancelDialog();
            },

            cancelDialog() {
                this.dialog = false;
                this.itemId = 0;
                this.dialogMessage = "";
                this.dialogType = null;
            },


            showDetails(item) {
                this.itemId = item.employeeLeaveId;
                this.view = 3;
                this.items.push({ text: "عرض التفاصيل" });

            },
            getAll(page) {
                this.filters.page = page || 1;
                this.$store.dispatch("leaves/getLeaves", this.filters);
            },
         
            back() {
                this.view = 0;
                this.items = [
                    {
                        text: "الاجازات ",
                    },
                    {
                        text: "طلبات الاجازات",
                    },
                ];
            },
            addItem() {
                this.view = 1;
                this.items.push({ text: "إضافة اجازة جديدة" });

            },
        },
    };
</script>
